import { useTranslation } from 'react-i18next';

export default function MercedesVideoSection() {
  const { t } = useTranslation();

  const legacyParagraphs = [
    t('home.mercedes.legacy_p1'),
    t('home.mercedes.legacy_p2'),
    t('home.mercedes.legacy_p3'),
    t('home.mercedes.legacy_p4'),
    t('home.mercedes.legacy_p5'),
    t('home.mercedes.legacy_p6'),
    t('home.mercedes.legacy_p7'),
  ];

  return (
    <section id="bienvenida" className="scroll-mt-24 py-10 md:py-14 px-6 md:px-10 bg-sand">
      <div className="max-w-4xl mx-auto">
        {/* Header con foto de Mercedes al costado del título */}
        <div className="mb-5">
          <span className="inline-block font-sans text-[11px] font-semibold text-terracotta uppercase tracking-[0.2em] mb-3">
            {t('home.mercedes.tag')}
          </span>

          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            {/* Foto de Mercedes */}
            <div className="w-14 h-14 md:w-16 md:h-16 rounded-full overflow-hidden border-[3px] border-white flex-shrink-0">
              <img
                src="https://storage.helloreaddy.io/project_files/33950b86-7657-493b-8177-e5932d2de9a1/9e064e6b-43da-4599-9aa5-450b1ce5ffb4_compressed_ChatGPT-Image-1-ago-2026-07_00_00-p.m.-2.webp"
                alt="Mercedes - NeuroBabys"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div>
              <h2 className="font-serif text-xl md:text-3xl font-bold text-brown leading-tight">
                {t('home.mercedes.title')}
              </h2>
              <p className="font-sans text-[13px] md:text-sm text-[#6B5A4E] mt-1.5 leading-relaxed max-w-xl">
                {t('home.mercedes.subtitle')}
              </p>
            </div>
          </div>
        </div>

        {/* Video — marco 16:9 completo, ancho total del bloque, centrado, sin recorte */}
        <div className="relative w-full aspect-video rounded-2xl overflow-hidden bg-black mb-7">
          <iframe
            src="https://www.youtube.com/embed/eXoQl1CKXQA"
            title={t('home.mercedes.title')}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
            className="absolute inset-0 w-full h-full border-0"
          />
        </div>

        {/* Texto del legado — compacto, de punta a punta */}
        <div className="font-sans text-[13px] md:text-sm text-[#3D2B1F] leading-relaxed space-y-2">
          {legacyParagraphs.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>
      </div>
    </section>
  );
}